import { ApiClient, ApiClientConfig } from "../../../api-client";
import { handleApiError } from "../../../errors";
import schemaValidators from "./schema-validators";
import { TypeFromSchemaValidator } from "../../../schema-validator";

export class WorkerLoggerClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, schemaValidators);
	}

	logFaceWorkerEvent = async ({
		sessionId,
		event,
	}: {
		sessionId: string;
		event: TypeFromSchemaValidator<typeof schemaValidators.faceWorkerEvent>;
	}) => {
		await handleApiError(
			super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${sessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(event),
			}),
		);
	};

	logObjectWorkerEvent = async ({
		sessionId,
		event,
	}: {
		sessionId: string;
		event: TypeFromSchemaValidator<typeof schemaValidators.objectWorkerEvent>;
	}) => {
		await handleApiError(
			super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${sessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(event),
			}),
		);
	};
}
